/* PET SHOP — comportements du thème
   Tout est délégué au document : les sections re-rendues (éditeur de thème,
   Section Rendering API) restent fonctionnelles sans ré-attacher d'écouteurs. */
(function () {
  'use strict';

  var Theme = window.PetShop = window.PetShop || {};
  Theme.routes = window.routes || {};

  /* ---------------------------------------------------------------- utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(type, selector, handler) {
    document.addEventListener(type, function (e) {
      var el = e.target.closest ? e.target.closest(selector) : null;
      if (el) handler(e, el);
    });
  }
  function lock(state) { document.body.classList.toggle('is-locked', state); }

  /* ------------------------------------------------------- barre d'annonce */
  function announcements() {
    $$('[data-announcement]').forEach(function (bar) {
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      if (bar.dataset.bound === '1') return;
      bar.dataset.bound = '1';
      var i = 0;
      var delay = parseInt(bar.dataset.speed, 10) || 3800;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, delay);
    });
  }

  /* ------------------------------------------------------------ menu mobile */
  function openMenu() { document.body.classList.add('menu-open'); lock(true); }
  function closeMenu() { document.body.classList.remove('menu-open'); lock(document.body.classList.contains('drawer-open')); }
  on('click', '[data-menu-open]', function (e) { e.preventDefault(); openMenu(); });
  on('click', '[data-menu-close]', function (e) { e.preventDefault(); closeMenu(); });
  on('click', '[data-menu-toggle]', function (e, el) {
    e.preventDefault();
    var sub = el.nextElementSibling;
    if (sub) sub.classList.toggle('is-open');
  });

  /* ---------------------------------------------------------------- panier */
  function openCart() { document.body.classList.add('drawer-open'); lock(true); }
  function closeCart() { document.body.classList.remove('drawer-open'); lock(document.body.classList.contains('menu-open')); }
  Theme.openCart = openCart;

  on('click', '[data-cart-open]', function (e) {
    if (document.body.dataset.cartType !== 'drawer') return; // panier = page
    e.preventDefault();
    openCart();
  });
  on('click', '[data-cart-close]', function (e) { e.preventDefault(); closeCart(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMenu(); }
  });

  function setLoading(state) {
    var drawer = $('[data-cart-drawer]');
    if (drawer) drawer.classList.toggle('is-loading', state);
  }

  /* Rafraîchit le tiroir + la pastille du panier à partir du HTML rendu par Liquid */
  function renderCart(sections) {
    var html = sections && (sections['cart-drawer'] || sections['cart_drawer']);
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-inner]');
      var target = $('[data-cart-drawer-inner]');
      if (fresh && target) target.innerHTML = fresh.innerHTML;
    }
    var root = $('[data-cart-drawer-inner]');
    var count = root ? parseInt(root.dataset.cartCount, 10) : 0;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !(count > 0);
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: count } }));
  }

  function cartRequest(url, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    setLoading(true);
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        setLoading(false);
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Erreur panier');
        renderCart(res.data.sections);
        return res.data;
      })
      .catch(function (err) { setLoading(false); throw err; });
  }

  Theme.addToCart = function (id, quantity, properties) {
    var item = { id: id, quantity: quantity || 1 };
    if (properties) item.properties = properties;
    return cartRequest(Theme.routes.cart_add_url || '/cart/add.js', { items: [item] });
  };
  Theme.changeLine = function (key, quantity) {
    return cartRequest(Theme.routes.cart_change_url || '/cart/change.js', { id: key, quantity: quantity });
  };

  /* Ajout au panier depuis une carte produit ou la fiche produit */
  on('submit', 'form[data-product-form]', function (e, form) {
    if (document.body.dataset.cartType !== 'drawer') return; // laisse le POST normal
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var id = form.querySelector('[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]');
    if (!id || !id.value) return;
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Ajout…'; }
    Theme.addToCart(id.value, qtyEl ? parseInt(qtyEl.value, 10) : 1)
      .then(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        openCart();
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        var box = form.querySelector('[data-form-error]');
        if (box) { box.textContent = err.message; box.hidden = false; }
        else alert(err.message);
      });
  });

  /* Quantités dans le tiroir */
  on('click', '[data-line-change]', function (e, el) {
    e.preventDefault();
    Theme.changeLine(el.dataset.lineKey, parseInt(el.dataset.lineChange, 10)).catch(function (err) { alert(err.message); });
  });
  on('click', '[data-line-remove]', function (e, el) {
    e.preventDefault();
    Theme.changeLine(el.dataset.lineKey, 0).catch(function (err) { alert(err.message); });
  });

  /* Sélecteur de quantité (fiche produit) */
  on('click', '[data-qty-step]', function (e, el) {
    e.preventDefault();
    var input = el.parentNode.querySelector('input[name="quantity"]');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += parseInt(el.dataset.qtyStep, 10);
    input.value = Math.max(1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* -------------------------------------------------------------------- FAQ */
  on('click', '.faq__q', function (e, btn) {
    e.preventDefault();
    var item = btn.closest('.faq__item');
    var panel = item.querySelector('.faq__a');
    var open = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
  });

  /* ------------------------------------------------------ sélecteur variante */
  function updateVariant(root) {
    var data = root.querySelector('[data-variants-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var chosen = $$('[data-option-value].is-selected', root).map(function (el) { return el.dataset.optionValue; });
    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === chosen[i]; });
    });
    var idInput = root.querySelector('[name="id"]');
    var btn = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-variant-price]');
    var compareEl = root.querySelector('[data-variant-compare]');
    var stockEl = root.querySelector('[data-variant-stock]');

    if (!match) {
      if (btn) { btn.disabled = true; btn.textContent = 'Indisponible'; }
      return;
    }
    if (idInput) idInput.value = match.id;
    if (priceEl) priceEl.innerHTML = match.price_formatted;
    if (compareEl) {
      compareEl.innerHTML = match.compare_at_formatted || '';
      compareEl.hidden = !match.compare_at_formatted;
    }
    if (btn) {
      btn.disabled = !match.available;
      btn.textContent = match.available ? (btn.dataset.labelAdd || 'Ajouter au panier') : 'Rupture de stock';
    }
    if (stockEl) {
      stockEl.hidden = false;
      stockEl.classList.toggle('stock--out', !match.available);
      stockEl.querySelector('[data-stock-label]').textContent = match.available ? 'En stock — expédié sous 24h' : 'Momentanément indisponible';
    }
    if (match.featured_media_id) {
      var thumb = root.querySelector('[data-media-id="' + match.featured_media_id + '"]');
      if (thumb) thumb.click();
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url.toString());
  }

  on('click', '[data-option-value]', function (e, el) {
    e.preventDefault();
    var group = el.closest('.option__values');
    $$('[data-option-value]', group).forEach(function (b) { b.classList.remove('is-selected'); });
    el.classList.add('is-selected');
    updateVariant(el.closest('[data-product-root]'));
  });

  /* ------------------------------------------------------------- galerie PDP */
  on('click', '[data-media-id]', function (e, el) {
    e.preventDefault();
    var root = el.closest('[data-product-root]') || document;
    var main = root.querySelector('[data-main-image]');
    if (main && el.dataset.src) {
      main.src = el.dataset.src;
      main.srcset = el.dataset.srcset || '';
      main.alt = el.dataset.alt || '';
    }
    $$('[data-media-id]', root).forEach(function (t) { t.classList.remove('is-active'); });
    el.classList.add('is-active');
  });

  /* ------------------------------------------------------- tri collection */
  on('change', '[data-sort]', function (e, el) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', el.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* --------------------------------------------------- reveal au défilement */
  function reveals() {
    if (!document.body.classList.contains('has-animations')) return;
    if (!('IntersectionObserver' in window)) {
      $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.reveal:not(.is-visible)').forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------ init */
  function init() {
    announcements();
    reveals();
    $$('[data-product-root]').forEach(function (root) {
      if (root.querySelector('[data-variants-json]')) updateVariant(root);
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  /* Éditeur de thème Shopify : ré-initialiser après un rendu de section */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) openCart();
  });
})();
